import graphql__939dea46f3bff5ae5a1e from "./__generated__/ConfirmAccountMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__939dea46f3bff5ae5a1e;

function confirmAccount(variables, onCompleted) {
  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { confirmAccount };
